module.exports = __webpack_public_path__ + "static/toumoulin-d51a48ebd9f00133cdfa7040d7e3e399.jpg";